import { render, staticRenderFns } from "./purrateview.vue?vue&type=template&id=7ab91f1b&scoped=true&"
import script from "./purrateview.vue?vue&type=script&lang=js&"
export * from "./purrateview.vue?vue&type=script&lang=js&"
import style0 from "./purrateview.vue?vue&type=style&index=0&id=7ab91f1b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab91f1b",
  null
  
)

export default component.exports